import { render, staticRenderFns } from "./InteractiveImage.vue?vue&type=template&id=847a4c38"
import script from "./InteractiveImage.vue?vue&type=script&lang=js"
export * from "./InteractiveImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports